import * as React from "react";
import { Grid } from "semantic-ui-react";

import { QuestionConfig, isQuestionDisabled, MasterQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig/models";
import { TermsAndConditionsOfUseConfig } from "@teamprevent/common/termsAndConditions/model";

interface Props {
    masterQuestion: MasterQuestionConfig;
    customQuestion: QuestionConfig;
    questionnaireType: string;
    customQuestionText?: string;
}

const getQuestionText = (props: Props) => {
    const question = props.customQuestion ?? props.masterQuestion;
    if (isQuestionDisabled(question)) {
        return "Question disabled";
    } else {
        return question.questionText;
    }
};

export const QuestionDetails: React.FunctionComponent<Props> = props => (
    <Grid container columns={2} divided className="question-config">
        <Grid.Row>
            {props.questionnaireType === TermsAndConditionsOfUseConfig
                ? (
                    <Grid.Column>
                        {props.customQuestionText}
                    </Grid.Column>
                )
                : (
                    <Grid.Column as="h4" className={isQuestionDisabled(props.customQuestion ?? props.masterQuestion) ? "question-disabled" : null}>
                        {props.masterQuestion.questionText}
                    </Grid.Column>
                )
            }
            <Grid.Column>
                {getQuestionText(props)}
            </Grid.Column>
        </Grid.Row>
    </Grid>
);
